module.exports = __webpack_public_path__ + "static/media/launchpad_logo.2b00e222.png";